import { ReactNode } from "react";
import { twJoin, twMerge } from "tailwind-merge";
import { Loader } from "../loader";
import { BaseButton, BaseButtonProps } from "./base-button";

const FILLED_VARIANTS = {
  sunburst: {
    background: "bg-sunburst",
    text: "text-white",
  },
  midnight: {
    background: "bg-midnight",
    text: "text-white",
  },
  "lac-leman": {
    background: "bg-lac-leman",
    text: "text-white",
  },
  lavaux: {
    background: "bg-lavaux",
    text: "text-white",
  },
  tint: {
    background: "bg-lac-leman-15",
    text: "text-lac-leman",
  },
};

type Props = BaseButtonProps & {
  startIcon?: ReactNode;
  // endIcon?: ReactNode;
  loading?: boolean;
  filled?: keyof typeof FILLED_VARIANTS;
};

export const Button = (props: Props) => {
  const { children, className, startIcon, loading, disabled, filled, ...restProps } = props;

  const filledVariant = filled ? FILLED_VARIANTS[filled] : null;

  return (
    <BaseButton
      {...restProps}
      disabled={disabled || loading}
      className={twMerge(
        "group relative block overflow-hidden whitespace-nowrap rounded-full px-2 py-1 font-semibold",
        (disabled || loading) && "opacity-50",
        filledVariant?.text ?? "text-lac-leman",
        !filled && "border border-lac-leman",
        className,
      )}>
      <div
        className={twJoin(
          "absolute inset-0 rounded-full transition-all group-focus-visible:inset-1",
          filledVariant?.background ?? "bg-lac-leman opacity-0",

          !loading &&
            !disabled &&
            (filled
              ? "group-hover:opacity-90 group-active:opacity-90"
              : "group-hover:text-white group-hover:opacity-10 group-active:opacity-10"),
        )}
      />

      <div
        className={twJoin(
          "relative flex items-center justify-center",
          loading && "invisible",
          // endIcon && "pl-3 pr-2",
          startIcon && "pl-2 pr-3",
        )}>
        {startIcon && <div className="mr-1">{startIcon}</div>}
        <div>{children}</div>
        {/* {endIcon && <div>{endIcon}</div>} */}
      </div>

      <div className={twJoin("absolute inset-0 m-auto h-fit w-fit", !loading && "invisible")}>
        <Loader size="small" />
      </div>
    </BaseButton>
  );
};
